<template>
  <div class="col-12 py-1 ms-4 w-75">
    <div class="row">
      <div class="col-auto p-1">
        <img
          src="@/assets/avatar.jpg"
          style="width: 30px"
          class="rounded-circle"
        />
      </div>
      <div class="col card bg-light border-info px-2">
        <div class="d-flex flex-column">
          <h6 class="card-title my-auto">
            Taha Malaldır<span class="text-muted" id="yorum-text"> - 1s</span>
          </h6>
          <p class="card-text lh-sm text-wrap" id="yorum-text">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Reiciendis
            dolore magni asperiores corporis nobis hic.
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="col-12 ms-5">
      <div class="btn fw-bold p-0 yorum">Beğen</div>
      |
      <div class="btn fw-bold p-0 yorum">Yanıtla</div>
    </div> -->
  </div>
</template>

<script>
export default {};
</script>

<style></style>
